module.exports = __webpack_public_path__ + "static/media/truck-illustration.56ec5036.svg";